import React from "react";
import Helmet from "react-helmet";
import Main from "../../components/main";
import Box from "../../components/box";
import A from "../../components/a";
import H1 from "../../components/h1";
import H3 from "../../components/h3";
import P from "../../components/p";
import Button from "../../components/button";
// import "./styles.css";

const Articles = () => (
  <Main>
    <Helmet>
      <title>Ghast.io: Articles</title>
      <meta
        name="description"
        content="Articles from the Ghast.io team, usually about technical subjects or things going on in the Minecraft PvP community in general."
      />
    </Helmet>
    <Box>
      <div style={{ marginBottom: 24 }}>
        <H1>Articles</H1>
        <P>
          Occasionally we write technical articles or cover current events in
          the Minecraft PvP community, or other types of content!
        </P>
      </div>

      <div style={{ marginBottom: 16 }}>
        <H3>HitDelayFixMod</H3>
        <P>Fix the hit delay in minecraft 1.8 pvp</P>
        <Button href="/hitdelayfixmod">HitDelayFixMod</Button>
      </div>
      <div style={{ marginBottom: 16 }}>
        <H3>Kohi Click Test</H3>
        <P>Check and improve your CPS with our test</P>
        <Button href="/kohi-click-test">Kohi Click Test</Button>
      </div>
    </Box>
  </Main>
);

export default Articles;



/** WEBPACK FOOTER **
 ** ./src/views/pages/articles/index.js
 **/